import loadable from '@loadable/component';

// Template
import AuthenticationTemplate from '../../components/auth/AuthenticationTemplate';

const PATH = '/auth';

const authenticationRoutes = {
  name: 'auth.root',
  path: PATH,
  component: AuthenticationTemplate,
  query: require('../../components/auth/__generated__/AuthenticationTemplateQuery.graphql'),
  routes: [
    {
      name: 'auth.login',
      path: `${PATH}/login`,
      component: loadable(() => import('../../components/auth/CandidateLogin')),
      exact: true,
      query: require('../../components/auth/__generated__/CandidateLoginQuery.graphql'),
    },
    {
      name: 'auth.register',
      path: `${PATH}/register`,
      component: loadable(() => import('../../components/auth/CandidateAdd')),
      exact: true,
      query: require('../../components/auth/__generated__/CandidateAddQuery.graphql'),
    },
    {
      name: 'auth.forgotPassword',
      path: `${PATH}/forgotPassword`,
      component: loadable(() => import('../../components/auth/ForgotPassword')),
      exact: true,
      query: require('../../components/auth/__generated__/ForgotPasswordQuery.graphql'),
    },
    {
      name: 'auth.changePassword',
      path: `${PATH}/changePassword`,
      component: loadable(() => import('../../components/auth/ChangePassword')),
      exact: true,
      query: require('../../components/auth/__generated__/ChangePasswordQuery.graphql'),
    },
  ],
};

export default authenticationRoutes;
